import { Flex, Text } from '@chakra-ui/react';
import {
	isCronHoursValue,
	isCronMinutesValue,
	isCronSecondsValue,
} from '@mayahq/cron';
import isNumber from 'lodash/isNumber';
import React, { useEffect, useState } from 'react';
import NumericPeriodValuesSelector from '../NumericPeriodValuesSelector';

/**
 *
 * @param {{
 * 	cronObject: import('@mayahq/cron').CronQuartz,
 * 	onCronObjectChange: (newCronObject: import('@mayahq/cron').CronQuartz) => void,
 *  	menuProps?: import('@chakra-ui/react').MenuProps,
 *		menuButtonProps?: import('@chakra-ui/react').MenuButtonProps & import('@chakra-ui/react').ButtonProps,
 *		menuListProps?: import('@chakra-ui/react').MenuListProps,
 *		menuItemProps?: import('@chakra-ui/react').MenuItemProps,
 * }} param0
 * @returns
 */
const EveryHoursSelector = ({
	cronObject,
	onCronObjectChange,
	menuProps,
	menuButtonProps,
	menuListProps,
	menuItemProps,
}) => {
	const [hours, setHours] = useState(() =>
		isCronHoursValue(cronObject?.hours?.every) ? cronObject.hours.every : 1
	);
	const [minutes, setMinutes] = useState(() =>
		isCronMinutesValue(cronObject?.minutes) ? cronObject.minutes : 0
	);
	const [seconds, setSeconds] = useState(() =>
		isCronSecondsValue(cronObject?.seconds) ? cronObject.seconds : 0
	);

	useEffect(() => {
		onCronObjectChange({
			seconds,
			minutes,
			hours: { every: hours, start: 0 },
			dayOfWeek: '*',
			dayOfMonth: '*',
			month: '*',
			year: '*',
		});
	}, [onCronObjectChange, hours, seconds, minutes]);

	return (
		<Flex mt="2" alignItems="center">
			<Text mr="1">Every</Text>
			<NumericPeriodValuesSelector
				selected={hours}
				onSelect={setHours}
				selectionRange={{
					from: 1,
					to: 24,
				}}
				menuProps={menuProps}
				menuButtonProps={menuButtonProps}
				menuListProps={menuListProps}
				menuItemProps={menuItemProps}
			/>
			<Text mx="1">hour(s) at</Text>
			<NumericPeriodValuesSelector
				selected={minutes}
				onSelect={setMinutes}
				selectionRange={{
					from: 0,
					to: 60,
				}}
				menuProps={menuProps}
				menuButtonProps={menuButtonProps}
				menuListProps={menuListProps}
				menuItemProps={menuItemProps}
			/>
			<Text mx="1">minute(s) and </Text>
			<NumericPeriodValuesSelector
				selected={seconds}
				onSelect={setSeconds}
				selectionRange={{
					from: 0,
					to: 60,
				}}
				menuProps={menuProps}
				menuButtonProps={menuButtonProps}
				menuListProps={menuListProps}
				menuItemProps={menuItemProps}
			/>
			<Text ml="1">second(s)</Text>
		</Flex>
	);
};

export default React.memo(EveryHoursSelector);
